import { render, staticRenderFns } from "./ProductLabelDropdownItem.vue?vue&type=template&id=43344310&scoped=true&"
import script from "./ProductLabelDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ProductLabelDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelDropdownItem.vue?vue&type=style&index=0&id=43344310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43344310",
  null
  
)

export default component.exports